import { RiskZonesIcon, SafetyIcon, SpeedingsIcon } from "@l2r-front/l2r-icons"

import { L2rAppSafety } from "../../app"

import { I18N_NAMESPACE } from "./i18n"
import { API_MODULE_RISK_ZONE, API_MODULE_SPEEDINGS, MODULE_RISK_ZONES, MODULE_SPEEDINGS } from "./modules"

export const APP_SAFETY = "safety"

export const appSafety = {
    index: 3,
    color: "primary",
    component: <L2rAppSafety />,
    icon: SafetyIcon,
    i18nNamespace: I18N_NAMESPACE,
    label: "app.label",
    modules: {
        risk_zones: {
            index: 0,
            icon: RiskZonesIcon,
            id: API_MODULE_RISK_ZONE,
            label: "app.modules.riskZones",
            path: MODULE_RISK_ZONES,
        },
        speedings: {
            index: 1,
            icon: SpeedingsIcon,
            id: API_MODULE_SPEEDINGS,
            label: "app.modules.speedings",
            path: MODULE_SPEEDINGS,
        },
    },
    path: APP_SAFETY,
}